<template>
  <div id="newModel" class="clearfix">
    <div class="left-box f-l">
      <!-- 设备列表 -->
      <div class="device-list box-bg bg1 p-r">
        <p class="list-title">设备列表</p>
        <p class="state-title" :style="{left:titleLeft+'px'}">
          <img src="../../../assets/image/indexEditor/model7/textLeft.png" />{{getState(stateValue)}}<img
            src="../../../assets/image/indexEditor/model7/textRight.png" />
        </p>
        <div class="state">
          <span class="state-lab" :class="{' labbg1':stateValue==1}"></span>
          <span class="state-lab" :class="{' labbg2':stateValue==2}"></span>
          <span class="state-lab" :class="{' labbg3':stateValue==3}"></span>
          <span class="state-lab" :class="{' labbg4':stateValue==4}"></span>
          <span class="state-lab" :class="{' labbg5':stateValue==5}"></span>
          <span class="state-lab" :class="{' labbg6':stateValue==6}"></span>
          <span class="state-lab" :class="{' labbg7':stateValue==7}"></span>
        </div>
        <div class="divice-boxs">
          <div class="device-box clearfix" v-for="(item,i) in data.deviceList" :key='i'
            :class="{'border-bg':(i+1)%3 !=0 }">
            <div class="f-l p-r">
              <span class="state-lamp"
                :class="[{'lx':item.offline},{'gj':!item.offline&&!item.open},{'jg':!item.offline&&item.open&&item.deviceState==2},{'gz':!item.offline&&item.open&&item.deviceState==3},{'zc':!item.offline&&item.open&&item.deviceState==1}]"></span>
              <img :src="item.image" class="device-img" v-default-img="deviceImg" @click="showData(item)">
            </div>
            <div class="attr-box f-l">
              <p style="height: 28px;" class="t-hide" :title="item.name">{{item.name}}</p>
              <progress-bar :data="proBarData(item)" :state='item.state' type="1" v-if="item.paceCode"></progress-bar>
              <div style="margin-top: 7px;" v-if="item.identifier1">{{item.propertyName1}}：<span
                  class="value">{{valueHTML(item,item.identifier1)}}</span></div>
              <div v-if="item.identifier2">{{item.propertyName2}}：<span
                  class="value">{{valueHTML(item,item.identifier2)}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="category-box box-bg bg2">
        <p class="list-title">数据曲线1</p>
        <div class="p-r">
          <div class="btns">
            <span @click="type=1" :class="{'active':type==1}">5分钟数据</span>
            <span @click="type=2" :class="{'active':type==2}">60分钟数据</span>
          </div>
          <div class="tuli" v-if="type==1&&data.curveOneData[0].dataset"><span style="color: #71AD33;"
              v-if="data.curveOneData[0].dataset.properties[0]"></span>{{data.curveOneData[0].dataset.properties[0]?data.curveOneData[0].dataset.properties[0].attrName:''}}<span
              style="color: #A035FD;margin-left: 10px;"
              v-if="data.curveOneData[0].dataset.properties[1]"></span>{{data.curveOneData[0].dataset.properties[1]?data.curveOneData[0].dataset.properties[1].attrName:''}}
          </div>
          <div class="tuli" v-if="type==2&&data.curveOneData[1].dataset"><span style="color: #71AD33;"
              v-if="data.curveOneData[1].dataset.properties[0]"></span>{{data.curveOneData[1].dataset.properties[0]?data.curveOneData[1].dataset.properties[0].attrName:''}}<span
              style="color: #A035FD;margin-left: 10px;"
              v-if="data.curveOneData[1].dataset.properties[1]"></span>{{data.curveOneData[1].dataset.properties[1]?data.curveOneData[1].dataset.properties[1].attrName:''}}
          </div>
        </div>
        <div ref="chart1" id="chart1"></div>
      </div>
    </div>
    <div class="center-box f-l">
      <div class="category-box2 box-bg bg3">
        <p class="list-title">数据曲线2</p>
        <div>
          <div class="btns">
            <span @click="active=1" :class="{'active':active==1}">露点数据</span>
            <span @click="active=2" :class="{'active':active==2}">流量数据</span>
          </div>
        </div>
        <div ref="chart2" id="chart2"></div>
      </div>
      <div class="data-boxs clearfix">
        <div class="f-l data-box box-bg bg4">
          <p class="list-title">小时单位能耗</p>
          <p class="value-title" :class="[{'pg':EnergyTitle=='偏高'},{'zj':EnergyTitle=='正常'},{'pd':EnergyTitle=='偏低'}]">
            {{EnergyTitle}}
          </p>
          <div class="yb-box p-r">
            <div class="zhizheng" :style="zzStyle(this.data.energyData.hourCode,1)">
              <div class="sjx1" :style="{borderBottomColor:EnergyColor2}"></div>
              <div class="sjx2" :style="{borderTopColor:EnergyColor2}"></div>
            </div>
            <div class="qiu" :style="zzStyle(this.data.energyData.DayCode,2)">
              <div class="neiqiu" :style="{borderColor:EnergyColor}"></div>
            </div>
            <div class="value-box">
              <p class="data-box-value">{{energyValue(this.data.energyData.hourCode)}}</p>
              <p class="data-box-unit">{{data.energyData.unit}}</p>
            </div>
          </div>
        </div>
        <div class="f-l data-box box-bg bg4">
          <p class="list-title">变频机运行速率</p>
          <div class="data-list">
            <p v-for="(item,i) in data.rateData" :title="item.name" v-if="item.name"><span
                class="name-span" :title="getTitle(item)">{{item.name}}</span>
              <progress-bar :data="getRateValue(item.value,item.deviceName)" type="2" style="display:inline-block;">
              </progress-bar>
            </p>
          </div>
        </div>
      </div>
      <div class="warning-box box-bg bg5">
        <p class="list-title">报警数据</p>
        <div class="waring-data">
          <div class="warning-lab">
            <p>{{hold[0].num}}</p>
            <img src="../../../assets/image/newmould/icon1.png">
            <div>存续总数</div>
          </div>
          <div class="warning-lab">
            <p>{{hold[1].num}}</p>
            <img src="../../../assets/image/newmould/icon2.png">
            <div>未确认</div>
          </div>
          <div class="warning-lab">
            <p>{{hold[2].num}}</p>
            <img src="../../../assets/image/newmould/icon3.png">
            <div>8小时内新增</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box f-l">
      <div class="now-data box-bg bg6">
        <p class="list-title">实时数据</p>
        <div class="list-data">
          <p class="t-hide" v-for="(item,i) in data.realTimeData" :key='i' v-if="item.name" :title="getTitle(item)"><span
              class="star2"></span>{{item.name}}：<span class="value">{{dataValue(item)}}<span class="unit">
                {{item.unit}}</span></span></p>
        </div>
      </div>
      <div class="now-data statistics box-bg bg7">
        <p class="list-title">统计数据</p>
        <div class="list-data">
          <p class='t-hide' v-for="(item,i) in data.statisticsData" :key='i' v-if="item.name" :title="getTitle(item)"><span
              class="star2"></span>{{item.name}}：<span class="value">{{dataValue(item)}}<span class="unit">
                {{item.unit}}</span></span></p>
        </div>
      </div>
    </div>
    <data-view :value="valueList" :device="deviceObj" ref="dataView" v-show="showDataView" @close="close"></data-view>
  </div>
</template>

<script>
  var company_arr = [ //企业数
    {
      name: '总数',
      identifier: '_company_total'
    },
    {
      name: '新增',
      identifier: '_company_newly'
    },
    {
      name: '在线',
      identifier: '_company_online'
    },
    {
      name: '停用',
      identifier: '_company_stop'
    },
  ]
  var user_arr = [ //用户数
    {
      name: '总数',
      identifier: '_user_total'
    },
    {
      name: '新增',
      identifier: '_user_newly'
    },
    {
      name: '在线',
      identifier: '_user_online'
    },
    {
      name: '停用',
      identifier: '_user_stop'
    },
    {
      name: '冻结',
      identifier: '_user_freeze'
    },
  ]
  var warning_arr = [ //报警树
    {
      name: '总数',
      identifier: '_alarm_total'
    },
    {
      name: '提示数量',
      identifier: '_alarm_level_infor'
    },
    {
      name: '警告数量',
      identifier: '_alarm_level_warm'
    },
    {
      name: '故障数量',
      identifier: '_alarm_level_error'
    },
  ]
  var fault_arr = [ //故障时间
    {
      name: '响应时间',
      identifier: '_fault_response_time'
    },
    {
      name: '恢复时间',
      identifier: '_fault_recovery_time'
    },
  ]
  var device_arr = [ //设备数
    {
      name: '总数',
      identifier: '_device_total'
    },
  ]

  import ProgressBar from "./ProgressBar.vue"
  import dataView from "./dataView.vue"
  export default {
    data() {
      return {
        deviceImg: require('@/assets/image/newmould/device.png'),
        EnergyColor: "",
        sendTime:true,
        EnergyColor2: "",
        atteValueData: [],
        deviceList: [],
        deviceObj: {},
        showDataView: false,
        tslList: [],
        valueList: [],
        sendCodeArr: [],
        VirtualFuncList: [],
        dataSetList: [],
        hold: [{}, {}, {}],
        mqttClient: {},
        VirtualDevice: {},
        type: 1,
        active: 1,
        timeArr: [],
        timeArr2: [],
        timeArr3: [],
        timeArr4: [],
        chartSet1: {},
        chartSet2: {},
        subscribeArr: [],
        stateValue: null,
        EnergyTitle: "",
        titleLeft: "",
        typePreview: false,
        //系统属性值 对象
        systemList: [{
            name: '企业数',
            code: '_company',
            arr: company_arr
          },
          {
            name: '用户数',
            code: '_user',
            arr: user_arr
          },
          {
            name: '报警数',
            code: '_alarm',
            arr: warning_arr
          },
          {
            name: '故障时间',
            code: '_fault',
            arr: fault_arr
          },
          {
            name: '设备数',
            code: '_device',
            arr: device_arr
          },
        ],
      }
    },
    components: {
      ProgressBar,
      dataView
    },
    props: {
      data: {
        default: {},
        type: Object
      }
    },
    computed: {
      // 获取设备名和属性
      getTitle(){
        return (item)=>{
          if(item.deviceName){
            return item.deviceName + '/' + item.name
          }
          return item.name
        }
      },
      energyValue() {
        return (obj, type) => {
          if(!obj) return ''
          let arr = this.valueList.filter(i => i.id == obj[0])[0]
          if (arr) {
            let list = arr.list,
              identifier = obj[1]
            let value = list.filter(i => i.code == identifier)[0]
            if(value){
              value = value.value
            }else{
              return ''
            }
            let dev = this.tslList.filter(i=>i.id==obj[0])[0]
            if(dev){
              let attr = dev.properties.filter(a=>a.identifier == identifier)[0]
              if(attr&&attr.dataType&&attr.dataType.specs.step){
                value = this.common.fmoney(Number(value), attr.dataType.specs.step)
              }
            }
            return Number(value)
          }
          return ''
        }
      },
      getState() {
        return (i) => {
          var title = ''
          switch (i) {
            case 1:
              title = '压力低故障';
              this.titleLeft = 302
              break;
            case 2:
              title = '压力低启机';
              this.titleLeft = 367
              break;
            case 3:
              title = '压力低报警';
              this.titleLeft = 432
              break;
            case 4:
              title = '压力正常';
              this.titleLeft = 498
              break;
            case 5:
              title = '压力高报警';
              this.titleLeft = 563
              break;
            case 6:
              title = '压力高卸载';
              this.titleLeft = 628
              break;
            case 7:
              title = '压力高故障';
              this.titleLeft = 693
              break;
          }
          return title
        }
      },
      zzStyle() {
        return (obj, type) => {
          if(!obj) return
          let arr = this.valueList.filter(i => i.id == obj[0])[0]
          if (arr) {
            let list = arr.list,
              identifier = obj[1]
            let value = list.filter(i => i.code == identifier)[0]
            if (value) {
              let deg;
              value = Number(value.value)
              if (type == 1) {
                if (value < 0.08) {
                  this.EnergyTitle = '偏低'
                  this.EnergyColor2 = "#9fa0a0"
                } else if (value < 0.16) {
                  this.EnergyTitle = '正常'
                  this.EnergyColor2 = "#13f9b8"
                } else {
                  this.EnergyTitle = '偏高'
                  this.EnergyColor2 = "#ef920a"
                }
                // 245:旋转总角度 0.25  数据总值，-125为左右各一半
                if (value > 0.25) {
                  deg = 122.5
                } else {
                  deg = 245 * (value / 0.25) - 122.5
                }

                return 'transform: rotate(' + deg + 'deg);'
              } else {
                if (value < 0.08) {
                  this.EnergyColor = "#9fa0a0"
                } else if (value < 0.16) {
                  this.EnergyColor = "#13f9b8"
                } else {
                  this.EnergyColor = "#ef920a"
                }
                // 256:旋转总角度 0.25  数据总值，-128为左右各一半
                if (value > 0.25) {
                  deg = 128
                } else {
                  deg = 256 * (value / 0.25) - 128
                }
                return 'transform: rotate(' + deg + 'deg);'
              }
              this.$forceUpdate()
            } else {
              if (type == 1) {
                return 'transform: rotate(-122.5deg);'
              } else {
                return 'transform: rotate(-128deg);'
              }
            }
          }
        }
      },
      proBarData() {
        return (obj) => {
          if (obj.paceCode) {
            let arr = this.valueList.filter(i => i.code == obj.deviceCode)[0]
            if (arr) {
              let list = arr.list
              let value = list.filter(i => i.code == obj.paceCode)
              value = value[0]?value[0].value:null
              if (value) {
                for (let item of obj.properties || []) {
                  if (obj.paceCode == item.identifier) {
                    let warnDown, warnUp, errorDown, errorUp, state = 2
                    if (item.dataType&&item.dataType.warnUp && item.dataType.warnUp <= value) {
                      state = 3
                    }
                    if (item.dataType&&item.dataType.warnDown && item.dataType.warnDown >= value) {
                      state = 3
                    }
                    if (item.dataType&&item.dataType.errorUp && item.dataType.errorUp <= value) {
                      state = 1
                    }
                    if (item.dataType&&item.dataType.errorDown && item.dataType.errorDown >= value) {
                      state = 1
                    }
                    obj.state = state
                  }
                }
                return Number(value)
              } else {
                return 0
              }
            } else {
              return 0
            }
          } else {
            return 0
          }

        }
      },
      valueHTML() {
        return (obj, v) => {
          let arr = this.valueList.filter(i => i.id == obj.id)[0]
          if (arr && obj.properties) {
            let list = arr.list
            let value = list.filter(i => i.code == v)
            if(value[0]){
              value = value[0].value
            }else{
              return ''
            }
            let dataType = obj.properties.filter(i => i.identifier == v)[0]
            if(!dataType){
              return ''
            }else{
              dataType = dataType.dataType
            }
            if (dataType.type == 'int' || dataType.type == 'float' || dataType.type == 'double') {
              return dataType.specs.unit ? this.common.fmoney(Number(value), dataType.specs.step) + dataType.specs
                .unit : this.common.fmoney(Number(value), dataType.specs.step)
            } else if (dataType.type == 'bool' || dataType.type == 'enum') {
              return dataType.specs[Number(value)]
            } else if (dataType.type == 'time') {
              return this.changeTime(Number(value))
            } else {
              return value
            }
          } else {
            return ''
          }

        }
      },
      getRateValue() {
        return (obj, name) => {
          let arr = this.valueList.filter(i => i.id == obj[0])[0]
          if (arr) {
            let list = arr.list,
              identifier = obj[1]
            let value = list.filter(i => i.code == identifier)
            if(value[0]){
              value = value[0].value
              return Number(value)
            }else{
              return 0
            }
          } else {
            return 0
          }

        }
      },
      dataValue() {
        return (obj) => {
          if (obj.deviceName == '虚拟设备') {
            let arr = this.valueList.filter(i => i.id == obj.value[0])[0]
            if (arr) {
              let list = arr.list
              let value = list.filter(i => i.code == obj.value[1])[0].value
              let attr = this.VirtualFuncList.filter(i=>i.code==obj.value[1])[0]
              if(attr&&attr.step){
                return this.common.fmoney(Number(value),attr.step)
              }
              return this.common.fmoney(Number(value))
            }
          } else {
            let arr = this.valueList.filter(i => i.id == obj.value[0])[0]
            if (arr) {
              let list = arr.list
              let value = list.filter(i => i.code == obj.value[1])[0]
              if (value) {
                value = value.value
                if (obj.properties) {
                  let dataType = obj.properties.filter(i => i.identifier == obj.value[1])[0]
                  if(!dataType){
                    return ''
                  }else{
                    dataType = dataType.dataType
                  }
                  if (dataType.type == 'int' || dataType.type == 'float' || dataType.type == 'double') {
                    obj.unit = dataType.specs.unit
                    return this.common.fmoney(Number(value), dataType.specs.step)
                  } else if (dataType.type == 'bool' || dataType.type == 'enum') {
                    return dataType.specs[Number(value)]
                  } else {
                    return value
                  }
                }
              }
            }

          }
        }
      },
      companyId() {
        return this.$store.state.companyId
      },
      // 获取设备名
      // getDeviceNameByCode(){
      //   return (code) => {
      //     let dev = this.deviceList.filter(item => { item.code == code })[0]
      //     if(dev){
      //       return dev.name
      //     }else{
      //       return ''
      //     }
      //   }
      // }
    },
    created() {
      // this.$store.state.HTMLminWidth=1920
      this.getVirtualDevice()
      this.getDevice()
      this.createClient()
      // this.getHold()
      this.getDataSet()
    },
    activated() {
      // 	if(self.$route.meta.updataMark) {

      // 		/*清空所有图表*/
      // 		let arr = document.getElementsByClassName('datasetBox');
      // 		for(let dom of arr) {
      // 			let ecarts = self.$echarts.getInstanceByDom(dom)
      // 			if(ecarts) {
      // 				ecarts.clear()
      // 			}
      // 		}
      // 		/*复原 防止截图错位*/
      // 		self.editorClear();

      // 		/*如果在首页编辑更新过 则重新加载*/
      // 		self.initScree();
      // 		self.$route.meta.updataMark = false;
      // 		localStorage.removeItem('updataMark');
      // 	}
    },
    mounted() {
      setTimeout(() => {
        this.sendDeviceMqtt()
      }, 2000)
    },
    methods: {
      close() {
        // console.log('close')
        this.showDataView = false
        this.$store.state.mask = false
        this.$forceUpdate()
      },
      showData(obj) {
        if(!obj.id){
          obj.id = this.deviceList.filter( i =>i.code == obj.deviceCode)[0]
        }
        this.deviceObj = obj
        this.$refs.dataView.clearArr()
        this.showDataView = true
        this.$store.state.mask = true
      },
      //发送设备mqtt
      sendDeviceMqtt() {
        // console.log(this.valueList)
        for (let item of this.valueList) {
          if (item.code) {
            var subscribeUrl = 'sys/device/' + item.code + '/property/push'
            this.mqttClient.subscribe(subscribeUrl, {
              qos: 1
            }, (error) => {
              if (!error) {
                this.subscribeArr.push(subscribeUrl)
                // console.log(subscribeUrl)
              }
            })
          }
        }
      },
      // 获取虚拟设备
      getVirtualDevice() {
        this.get('/VirtualDevice/get', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.VirtualDevice = res.result
          }
        })
      },
      // 获取报警分类
      getwarnData() {
        this.get('/Dict/getListByType', {
          type: 2
        }).then((res) => {
          // this.warnData=res.result
          for (let item of res.result) {
            let obj = {
              name: item.name,
              identifier: '_alarm_category_' + item.id
            }
            warning_arr.push(obj)
          }
        })
      },
      // 获取存续数据
      getHold() {
        this.get('/DeviceAlarm/countCompanyAlarmByType', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.hold = res.result
          }
        })
      },
      //获取数据集列表
      getDataSet() {
        this.get('/Dataset/getList', {
          code: this.$store.state.companyCode
        }).then(res => {
          if (res.success) {
            this.dataSetList = res.result
            // 设置数据曲线
            this.infoCurve()
          }
        })
      },
      //获取虚拟设备的属性列表
      getVirtualFuncList(id) {
        if(!id&&id!=0){ return }
        let parm = {
          deviceId: id,
          companyId: this.companyId
        }
        this.get('/VirtualDevice/getPropertyList', parm).then((res) => {
          if (res.success) {
            this.VirtualFuncList = res.result
          }
        }).then(() => {
          this.get('/VirtualDevice/getPropertyValue', {
            deviceId: id
          }).then((res) => {
            if (res.success) {
              let obj = {
                code: this.VirtualDevice.code,
                id: id,
                list: res.result
              }
              if (!this.valueList.filter(i => i.code == this.VirtualDevice.code)[0]) {
                this.valueList.push(obj)
              }
            }
          })
        })
      },
      getDevice() {
        this.get('/Device/getList', {
          companyId: this.companyId
        }).then(res => {
          if (res.success) {
            this.deviceList = res.result
            for (let obj of res.result) {
              device_arr.push(obj)
            }
            // 获取设备的tsl
            this.infoDevice()
            // 获取加载速率
            this.infoRate()
            // 获取右侧设备数据
            this.infoData()
            this.infoEnergyData()
            this.infoStateData()
          } else {
            this.$message({
              message: `获取设备列表失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 获取关联设备的tsl
      infoDevice() {
        this.tslList = [], this.sendCodeArr = [], this.valueList = [];
        for (let dev of this.data.deviceList) {
          if (dev.deviceCode) {
            // 设备默认在线,避免修改到已经设置的状态
            dev.deviceState = 1
            if (this.tslList.filter(i => i.code == dev.deviceCode)[0]) {
              dev.properties = this.tslList.filter(i => i.code == dev.deviceCode)[0].properties
              this.resetName(dev)
              this.getOpen(dev)
            } else {
              let proList = this.deviceList.filter(i => i.code == dev.deviceCode)[0].propertySet.split(',')
              let id = this.deviceList.filter(i => i.code == dev.deviceCode)[0].id
              dev.id = id
              this.get('/ProductFeature/getByDeviceCode', {
                companyId: this.companyId,
                code: dev.deviceCode
              }).then(res => {
                if (res.success) {
                  let properties = JSON.parse(res.result).properties,
                    list = properties.filter(i => proList.includes(i.identifier))

                  let obj = {
                    code: dev.deviceCode,
                    id: id,
                    properties: list
                  }
                  this.tslList.push(obj)
                  dev.properties = list
                  this.resetName(dev)
                  this.$forceUpdate()
                }
              }).then(() => {
                this.getOpen(dev)
                if (!this.sendCodeArr.includes(dev.deviceCode)) {
                  this.sendCodeArr.push(dev.deviceCode)
                  this.getValue(dev.deviceCode, id)
                }
              })
            }
          }
        }
      },
      // 更新设备属性名
      resetName(dev){
        let dev1 = this.deviceList.filter(item => item.code == dev.deviceCode)[0]
        if(dev1){
          dev.name = dev1.name
        }
        if(dev.properties){
          let name1,name2
          name1 = dev.properties.filter(attr => attr.identifier == dev.identifier1)[0]
          name2 = dev.properties.filter(attr => attr.identifier == dev.identifier2)[0]
          if(name1){
            dev.propertyName1 = name1.name
          }
          if(name2){
            dev.propertyName2 = name2.name
          }
        }
      },
      resetName2(dev){
        if(dev.properties){
          let name = dev.properties.filter(attr => attr.identifier == dev.value[1])[0]
          if(name){
            dev.name = name.name
          }
        }
      },
      // 获取设备属性值
      getValue(code, id, isState) {
        this.get('/Device/getPropertyValue', {
          companyId: this.companyId,
          deviceId: id
        }).then((res) => {
          if (res.success) {
            let obj = {
              code: code,
              id: id,
              list: res.result
            }
            if (!this.valueList.filter(i => i.id == id)[0]) {
              this.valueList.push(obj)
            } else {
              this.valueList.filter(i => i.id == id)[0].list = res.result
            }
            if (isState) {
              let data = obj.list.filter(i => i.code == this.data.stateData[1])[0]
              if (data) {
                this.stateValue = Number(data.value)
                this.$forceUpdate()
              }
            }
          }
        })
      },
      getOpen(obj) {
        let device = this.deviceList.filter(i => i.code == obj.deviceCode)[0]
        this.get('/Device/getPropertyValue', {
          companyId: this.companyId,
          deviceId: device.id
        }).then((res) => {
          if (res.success) {
            // console.log(res.result.filter(i=>i.code==obj.offlineCode)[0])
            let value = res.result.filter(i => i.code == obj.offlineCode)[0]
            if (value) {
              obj.open = Number(value.value)
              // if(value==1){
              //   obj.open = 1
              // }else{
              //   obj.open = 0
              // }
            }
            this.$forceUpdate()
          }
        })
        let subscribeUrl = 'sys/device/' + obj.deviceCode + '/status/push'
        if (!this.subscribeArr.includes(subscribeUrl)) {
          this.mqttClient.subscribe(subscribeUrl, {
            qos: 1
          }, (error) => {
            if (!error) {
             this.subscribeArr.push(subscribeUrl)
            }
          })
        }

      },
      setOpen(obj) {
        let data = this.valueList.filter(i => i.code == obj.deviceCode)[0]
        if (data) {
          let value = data.list.filter(i => i.code == obj.offlineCode)[0]
          if (value) {
            obj.open = Number(value.value)
            // if(value==0){
            //   obj.open = 1
            // }else{
            //   obj.open = 0
            // }
            this.$forceUpdate()
          }
        }

      },
      infoCurve() {
        if (this.data.curveOneData[0].id) {
          let obj = this.dataSetList.filter(i => i.id == this.data.curveOneData[0].id)[0]
          if (obj) {
            this.getName(obj)
            this.data.curveOneData[0].dataset = obj
            this.sendCurveOneMqtt(obj)
          }
        }
        if (this.data.curveOneData[1].id) {
          let obj = this.dataSetList.filter(i => i.id == this.data.curveOneData[1].id)[0]
          if (obj) {
            this.getName(obj)
            this.data.curveOneData[1].dataset = obj
            // 数据曲线1里5分钟数据和60分钟数据关联同样的数据集时不发送mqtt
            if(this.data.curveOneData[0].id&&this.data.curveOneData[0].id != this.data.curveOneData[1].id){
              this.sendCurveOneMqtt(obj)
            }
          }
        }
        if (this.data.curveTwoData.dewId) {
          let obj = this.dataSetList.filter(i => i.id == this.data.curveTwoData.dewId)[0]
          if (obj) {
            this.data.curveTwoData.dewDataset = this.clone(obj)
            this.getName(this.data.curveTwoData.dewDataset)
            this.sendCurveOneMqtt(this.data.curveTwoData.dewDataset)
          }
        }
        if (this.data.curveTwoData.flowId) {
          let obj = this.dataSetList.filter(i => i.id == this.data.curveTwoData.flowId)[0]
          if (obj) {
            this.data.curveTwoData.flowDataset = this.clone(obj)
            this.getName(this.data.curveTwoData.flowDataset)
            this.sendCurveOneMqtt(this.data.curveTwoData.flowDataset)
          }
        }
        this.setchart1(this.data.curveOneData[0])
        if (this.data.curveTwoData.dewId) {
          this.setchart2(this.data.curveTwoData.dewDataset)
        } else if (this.data.curveTwoData.flowId) {
          this.active = 2
          this.setchart2(this.data.curveTwoData.flowDataset)
        }
      },
      getName(obj) {
        for (let item of obj.properties) {
          if (item.type == 1 || item.type == 2) {
            this.getTslName(item, item.type)
          } else {
            var arr = this.systemList.filter(i => i.code == item.code)[0].arr
            var name = arr.filter(i => i.identifier == item.property)[0].name
            item.attrName = name
          }
        }
      },
      async getTslName(item, type) {
        if (type == 1) {
          await this.get('/ProductFeature/get', {
            code: item.code
          }).then(res => {
            if (res.success) {
              let properties = JSON.parse(res.result).properties,
              attr = properties.filter(i => i.identifier == item.property)[0]
              if(attr&&attr.dataType){
                item.attrName = attr.name
                item.unit = attr.dataType.specs.unit || ''
              }else{
                item.attrName =''
                item.unit = ''
              }
            }
          })
        } else {
          await this.get('/ProductFeature/getByDeviceCode', {
            companyId: this.companyId,
            code: item.code
          }).then(res => {
            if (res.success) {
              let properties = JSON.parse(res.result).properties,
              attr = properties.filter(i => i.identifier == item.property)[0]
              if(attr&&attr.dataType){
                item.attrName = attr.name
                item.unit = attr.dataType.specs.unit || ''
              }else{
                item.attrName =''
                item.unit = ''
              }
            }
          })
        }
      },
      // 能耗
      infoEnergyData() {
        if (this.data.energyData.hourCode&&this.data.energyData.hourCode.length > 0) {
          let code = this.deviceList.filter(i => i.id == this.data.energyData.hourCode[0])[0].code
          this.getValue(code, this.data.energyData.hourCode[0])
        }
        if (this.data.energyData.DayCode&&this.data.energyData.DayCode.length > 0) {
          let code = this.deviceList.filter(i => i.id == this.data.energyData.DayCode[0])[0].code
          this.getValue(code, this.data.energyData.DayCode[0])
        }
      },
      infoStateData() {
        if (this.data.stateData.length > 0&&this.data.energyData.DayCode) {
          let code = this.deviceList.filter(i => i.id == this.data.energyData.DayCode[0])[0].code
          this.getValue(code, this.data.stateData[0], true)
        }
      },
      setState() {
        if (this.data.stateData.length > 0&&this.data.energyData.DayCode) {
          let code = this.deviceList.filter(i => i.id == this.data.energyData.DayCode[0])[0].code
          let list = this.valueList.filter(i => i.code == code)[0].list
          let data = list.filter(i => i.code == this.data.stateData[1])[0]
          if (data) {
            this.stateValue = Number(data.value)
            // console.log(this.stateValue)
            this.$forceUpdate()
          }
        }
      },
      // 加载速率
      infoRate() {
        for (let item of this.data.rateData) {
          if (item.name) {
            let id = item.value[0]
            let dev1 = this.deviceList.filter(i => i.id == id)[0]
            if(dev1){
              item.name = dev1.name
            }
            if (this.valueList.filter(i => i.id == id).length == 0) {
              if (item.deviceName == '虚拟设备') {
                this.getVirtualFuncList(id)
              } else {
                let code = this.deviceList.filter(i => i.id == id)[0].code
                this.getValue(code, id)
                if (this.tslList.filter(i => i.id == item.value[0])[0]) {
                  item.properties = this.tslList.filter(i => i.id == tem.value[0])[0].properties
                  this.resetName2(item)
                } else {
                  let dev = this.deviceList.filter(i => i.id == item.value[0])[0]
                  if (dev) {
                    this.get('/ProductFeature/getByDeviceCode', {
                      companyId: this.companyId,
                      code: dev.code
                    }).then(res => {
                      if (res.success) {
                        let proList = this.deviceList.filter(i => i.code == dev.code)[0].propertySet.split(',')
                        let properties = JSON.parse(res.result).properties,
                          list = properties.filter(i => proList.includes(i.identifier))
                        let obj = {
                          code: dev.code,
                          id: item.value[0],
                          properties: list
                        }
                        this.tslList.push(obj)
                        item.properties = list
                        this.resetName2(item)
                        this.$forceUpdate()
                      }
                    })
                  }
                }

              }
            }


          }
        }
      },
      // 实时数据和统计数据
      infoData() {
        for (let item of this.data.realTimeData) {
          if (item.deviceName && item.deviceName == '虚拟设备') {
            if (!this.valueList.filter(i => i.id == item.value[0])[0]) {
              this.getVirtualFuncList(item.value[0])
            }
          } else if (item.deviceName) {
            let dev1 = this.deviceList.filter(i => i.id == item.value[0])[0]
            if(dev1){
              item.deviceName = dev1.name
            }
            if (this.tslList.filter(i => i.id == item.value[0])[0]) {
              item.properties = this.tslList.filter(i => i.id == tem.value[0])[0].properties
              this.resetName2(item)
            } else {
              let dev = this.deviceList.filter(i => i.id == item.value[0])[0]
              if (dev) {
                this.get('/ProductFeature/getByDeviceCode', {
                  companyId: this.companyId,
                  code: dev.code
                }).then(res => {
                  if (res.success) {
                    let proList = this.deviceList.filter(i => i.code == dev.code)[0].propertySet.split(',')
                    let properties = JSON.parse(res.result).properties,
                      list = properties.filter(i => proList.includes(i.identifier))
                    let obj = {
                      code: dev.code,
                      id: item.value[0],
                      properties: list
                    }
                    this.tslList.push(obj)
                    item.properties = list
                    this.resetName2(item)
                    this.$forceUpdate()
                  }
                }).then(() => {
                  if (!this.sendCodeArr.includes(dev.code)) {
                    this.sendCodeArr.push(dev.code)
                    this.getValue(dev.code, item.value[0])
                    // console.log(dev)
                  }
                })
              }
            }

          }
        }
        for (let item of this.data.statisticsData) {
          if (item.deviceName && item.deviceName == '虚拟设备') {
            if (!this.valueList.filter(i => i.id == item.value[0])[0]) {
              this.getVirtualFuncList(item.value[0])
            }
          } else if (item.deviceName) {
            let dev1 = this.deviceList.filter(i => i.id == item.value[0])[0]
            if(dev1){
              item.deviceName = dev1.name
            }
            if (this.tslList.filter(i => i.id == item.value[0])[0]) {
              item.properties = this.tslList.filter(i => i.id == tem.value[0])[0].properties
              this.resetName2(item)
            } else {
              let dev = this.deviceList.filter(i => i.id == item.value[0])[0]
              if (dev) {
                this.get('/ProductFeature/getByDeviceCode', {
                  companyId: this.companyId,
                  code: dev.code
                }).then(res => {
                  if (res.success) {
                    let proList = this.deviceList.filter(i => i.code == dev.code)[0].propertySet.split(',')
                    let properties = JSON.parse(res.result).properties,
                      list = properties.filter(i => proList.includes(i.identifier))
                    let obj = {
                      code: dev.code,
                      id: item.value[0],
                      properties: list
                    }
                    this.tslList.push(obj)
                    item.properties = list
                    this.resetName2(item)
                    this.$forceUpdate()
                  }

                }).then(() => {
                  if (!this.sendCodeArr.includes(dev.deviceCode)) {
                    this.sendCodeArr.push(dev.deviceCode)
                    this.getValue(dev.deviceCode, item.value[0])
                  }
                })
              }
            }
          }
        }
      },
      //计算最大值
      calMax(arr) {
        let max = 0;
        arr.forEach(i => {
          if (max < i) {
            max = i
          }
        })
        let maxint = Math.ceil(max / 10); //不让最高的值超过最上面的刻度
        let maxval = maxint * 12; //让显示的刻度是整数
        return maxval;
      },

      //计算最小值
      calMin(arr) {
        if(arr.length==0){
          return 0
        }else{
          let min=arr[0];
          arr.forEach(i => {
            if (min > i) {
              min = i
            }
          })
          let minint = Math.floor(min / 15);
          let minval = minint * 12; //让显示的刻度是整数
          return minval;
        }

      },
      getUnit(name, i) {
        let obj = this.data.curveOneData[0].dataset.properties.filter(item => item.attrName == name)[0]
        if (obj) {
          return obj.unit || ''
        } else {
          return ''
        }
      },
      async setchart1(obj) {
        /*
        obj => 数据集对象
        data => 数据集数据
        */
        if(!obj||this.$store.state.headerActive != 0){
           return
        }
        if(!obj.dataset){ return}
        var ratio = obj.dataset.ratio || 1; //修正系数
        var place = obj.dataset.place; //保留小数
        var properties = obj.dataset.properties
        var yAxis, series, dom;
        if (properties.length >= 2) {
          properties[0].color = "#00ffad"
          properties[1].color = "#981aea"
          dom = this.$refs.chart1
          var Min1 = await this.calMin(properties[0].value || []),
            Min2 = await this.calMin(properties[1].value || []),
            Max1 = await this.calMax(properties[0].value || []),
            Max2 = await this.calMax(properties[1].value || [])

          yAxis = [{
                name: properties[0].unit ? properties[0].attrName + '(' + properties[0].unit + ')' : properties[0]
                  .attrName,
                type: 'value',
                max: Max1,
                // min: function(value) {
                //   let ret;
                //   let min = String(value.min)
                //   let arr = min.split('.')
                //   if(arr.length == 1){
                //     ret = value.min
                //   }else{
                //     let decimal = arr[1].split('')
                //     ret = Number(arr[0]+'.'+decimal[0])
                //   }
                //   return ret
                // },
                min:Min1,
                splitNumber: 6,
                interval: (Max1 - Min1) / 6,
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: "dashed",
                    color: "#505665"
                  },
                }
              },
              {
                name: properties[1].unit ? properties[1].attrName + '(' + properties[1].unit + ')' : properties[1]
                  .attrName,
                type: 'value',
                max: Max2,
                // min: function(value) {
                //   let ret;
                //   let min = String(value.min)
                //   let arr = min.split('.')
                //   if(arr.length == 1){
                //     ret = value.min
                //   }else{
                //     let decimal = arr[1].split('')
                //     ret = Number(arr[0]+'.'+decimal[0])
                //   }
                //   return ret
                // },
                min:Min2,
                splitNumber: 6,
                interval: (Max2 - Min2) / 6,
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: "dashed",
                    color: "#505665"
                  }
                }
              }
            ],
            series = [{
              data: properties[0].value || [],
              type: 'line',
              name: properties[0] ? properties[0].attrName : '',
              color: properties[0].color,
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 2,
                color: properties[0].color
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [{
                    offset: 0.25,
                    color: '#092f35' // 25% 处的颜色
                  }, {
                    offset: 0.85,
                    color: '#062126' // 50% 处的颜色
                  }, {
                    offset: 0.95,
                    color: '#062126' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }, {
              data: properties[1].value || [],
              type: 'line',
              position: "right",
              yAxisIndex: 1,
              name: properties[1] ? properties[1].attrName : "",
              color: properties[1].color,
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 2,
                color: properties[1].color
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [{
                    offset: 0.25,
                    color: '#242145' // 25% 处的颜色
                  }, {
                    offset: 0.85,
                    color: '#1a1832' // 50% 处的颜色
                  }, {
                    offset: 0.95,
                    color: '#1a1832' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }]
        } else if (properties.length == 1) {
          dom = this.$refs.chart1
          properties[0].color = "#00ffad"
          var Min1 = await this.calMin(properties[0].value || []),
            Max1 = await this.calMax(properties[0].value || []),

            yAxis = [{
              name: properties[0].unit ? properties[0].attrName + '(' + properties[0].unit + ')' : properties[0]
                .attrName,
              type: 'value',
              max: Max1,
              min: Min1,
              // min: function(value) {
              //   let ret;
              //   let min = String(value.min)
              //   let arr = min.split('.')
              //   if(arr.length == 1){
              //     ret = value.min
              //   }else{
              //     let decimal = arr[1].split('')
              //     ret = Number(arr[0]+'.'+decimal[0])
              //   }
              //   return ret
              // },

              interval: 6,
              splitNumber: (Max1 - Min1) / 6,
              splitLine: {
                show: true,
                lineStyle: {
                  type: "dashed",
                  color: "#505665"
                },
              }
            }],
            series = [{
              data: properties[0].value || [],
              type: 'line',
              name: properties[0].attrName,
              color: properties[0].color,
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 2
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [{
                    offset: 0.25,
                    color: '#094f4c' // 25% 处的颜色
                  }, {
                    offset: 0.85,
                    color: '#062126' // 50% 处的颜色
                  }, {
                    offset: 0.95,
                    color: '#062126' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }]
        }
        var t = this
        var option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.4)', // 提示框浮层的背景颜色
            borderColor: 'rgba(0,0,0,0.1)', // 提示框浮层的边框颜色。
            axisPointer: {
              type: "line"
            },
            formatter: function(params) {
              let html =
                `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${t.showrq(Number(params[0].name))}</span><br>`;
              for (let i in params) {
                html +=
                  '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;background-color:' +
                  params[i].color + ';"></span>'
                html +=
                  `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${params[i].seriesName}</span>：` +
                  '<span style="color:' + params[i].color +
                  ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">' + params[i].value + ' ' + t.getUnit(
                    params[i].seriesName, 1) + '<br>' + '</span>'
                // if(properties[i]){
                //   html += '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;background-color:'+properties[i].color+';"></span>'
                //   if (i==0) {
                //     if(properties[0].unit){
                //       html += `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${params[0].attrName}</span>：` + '<span style="color:' + properties[0].color + ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">'+ params[i].value +' '+ properties[0].unit +'<br>' + '</span>'
                //     }else{
                //       html += `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${properties[0].attrName}</span>：` + '<span style="color:' + properties[0].color + ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">'+ params[i].value + '<br>' + '</span>'
                //     }
                //   } else {
                //     if(properties[1].unit){
                //       html += `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${properties[1].attrName}</span>：` + '<span style="color:' + properties[1].color + ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">'+ params[i].value +' '+ properties[1].unit +'<br>' + '</span>'
                //     }else{
                //       html += `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${properties[1].attrName}</span>：` + "：" + '<span style="color:' + properties[1].color + ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">'+ params[i].value + '<br>' + '</span>'
                //     }
                //   }
                // }
              }
              return html
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.type == 1 ? this.timeArr : this.timeArr3,
            axisLabel: {
              formatter: (val) => {
                return t.showsj(Number(val))
              }
            }
          },
          yAxis: yAxis,
          series: series,
          grid: {
            left: '60',
            right: '60',
            bottom: '30',
            top: '60'
          },
        };
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("chart1"))
        if (Dom == null) {
          this.chartSet1 = this.$echarts.init(dom, '', {
            width: dom.offsetWidth, //设置宽高
            height: dom.offsetHeight
          })
        }
        this.chartSet1.setOption(option, true)
        this.$forceUpdate()
      },
      async setchart2(obj) {
        // if (document.getElementById('chart2') == null) {
        //   return
        // }else{
        //   this.$echarts.dispose(document.getElementById('chart2'))
        // }
        if(!obj||this.$store.state.headerActive != 0) return
        var ratio = obj.ratio || 1; //修正系数
        var place = obj.place; //保留小数
        var properties = obj.properties
        var dom = this.$refs.chart2,
          yAxis, series;
        var Min1 = await this.calMin(properties[0].value || []),
          Max1 = await this.calMax(properties[0].value || []),
          yAxis = [{
            name: properties[0].unit ? properties[0].attrName + '(' + properties[0].unit + ')' : properties[0]
              .attrName,
            type: 'value',
            align :"left",
            nameTextStyle:{
              padding:[0,0,0,40]
            },
            max: Max1,
            min:Min1,
            // min:  function(value) {
            //   let ret;
            //   let min = String(value.min)
            //   let arr = min.split('.')
            //   if(arr.length == 1){
            //     ret = value.min
            //   }else{
            //     let decimal = arr[1].split('')
            //     ret = Number(arr[0]+'.'+decimal[0])
            //   }
            //   return ret
            // },
            splitNumber: 6,
            interval: (Max1 - Min1) / 6,
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#505665"
              },
            }
          }],
          series = [{
            data: properties[0].value || [],
            type: 'line',
            name: properties[0].attrName,
            color: "#00cdff",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [{
                  offset: 0.25,
                  color: '#112f43' // 25% 处的颜色
                }, {
                  offset: 0.85,
                  color: '#0f2738' // 50% 处的颜色
                }, {
                  offset: 0.95,
                  color: '#0f2738' // 50% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          }]
        var t = this;
        var option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.4)', // 提示框浮层的背景颜色
            borderColor: 'rgba(0,0,0,0.1)', // 提示框浮层的边框颜色。
            axisPointer: {
              type: "line"
            },
            formatter: function(params) {
              let html =
                `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${t.showrq(Number(params[0].name))}</span><br>`;
              for (let item of params) {
                html +=
                  '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
                  item.color + ';"></span>'
                if (properties[0].unit) {
                  html +=
                    `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${properties[0].attrName}</span>：` +
                    '<span style="color:' + item.color +
                    ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">' + item.value + ' ' + properties[0]
                    .unit + '<br></span>'
                } else {
                  html +=
                    `<span style="font-size:12px;color:#C4E1FF;font-weight:400;">${properties[0].attrName}</span>：` +
                    '<span style="color:' + item.color +
                    ';font-family: AgencyFB;font-size: 16px;font-weight: bold;">' + item.value + '<br></span>'
                }
              }
              return html
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.active == 1 ? this.timeArr2 : this.timeArr4,
            axisLabel: {
              formatter: (val) => {
                return t.showsj(Number(val))
              }
            }
          },
          yAxis: yAxis,
          series: series,
          grid: {
            left: '50',
            right: '40',
            bottom: '40',
            top: '40'
          },
        };
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("chart2"))
        if (Dom == null) {
          this.chartSet2 = this.$echarts.init(dom, '', {
             width: dom.offsetWidth, //设置宽高
             height: dom.offsetHeight
          })
        }
        // console.log(option,this.data.curveTwoData)
        // this.chartSet2.clear();
        this.chartSet2.setOption(option, true)
        this.$forceUpdate()
      },

      // 创建mqtt
      createClient() {
        let clientId = ''
        if (this.typePreview) {
          clientId = this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_mould_Preview'
        } else {
          clientId = this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_mould'
        }
        let options = {
          clientId: clientId,
          connectTimeout: 600000,
          clean: true
        }
        this.mqttClient = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
        this.getMqttMessage()
      },
      // 订阅数据曲线1
      sendCurveOneMqtt(obj) {
        let subscribeUrl
        if (obj.type == 1) {
          subscribeUrl = `sys/dataset/${obj.id}/${obj.groupCode}/push`
        } else {
          subscribeUrl = `sys/dataset/${obj.id}/push`
        }
        if (this.subscribeArr.includes(subscribeUrl)) {
          return
        }
        this.subscribeArr.push(subscribeUrl)
        this.mqttClient.subscribe(subscribeUrl, {
          qos: 1
        }, (error) => {
          if (error) {
            this.subscribeArr.splice(this.subscribeArr.length-1,1)
          }
        })
      },
      getMqttMessage() {
        let t = this
        t.mqttClient.on('message', (topic, message) => {
          // 数据集更新
          let item = JSON.parse(message.toString()); //转码
          if (topic.indexOf('sys/dataset') != -1) {
            if (topic.indexOf(t.data.curveOneData[0].id) != -1) {
              let data = t.data.curveOneData[0].dataset.properties
              let ratio = t.data.curveOneData[0].dataset.ratio || 1
              let place = t.data.curveOneData[0].dataset.place || 0
              var timePush = false
              for (let attr of data) {
                if (attr.property == item.propertyCode && item.value.length>0) {
                  timePush = true
                  if (!attr.value) {
                    attr.value = []
                  }
                  if (timePush&& t.timeArr.length == attr.value.length) {
                    t.timeArr.push(item.time)
                    let value = Number(item.value[0] * ratio)
                    attr.value.push(value.toFixed(place).toString())
                    if(t.timeArr.length >= 16){
                      t.timeArr.splice(0,t.timeArr.length - 15)
                    }
                    if(attr.value.length >= 16){
                      attr.value.splice(0,attr.value.length - 15)
                    }
                  }
                }
              }
            }
            if (topic.indexOf(t.data.curveOneData[1].id) != -1) {
              let data = t.data.curveOneData[1].dataset.properties
              let ratio = t.data.curveOneData[1].dataset.ratio || 1
              let place = t.data.curveOneData[1].dataset.place || 0
              var timePush = false
              for (let attr of data) {
                if (attr.property == item.propertyCode && item.value.length>0) {
                  timePush = true
                  if (!attr.value) {
                    attr.value = []
                  }
                  if (timePush&& t.timeArr3.length == attr.value.length) {
                    t.timeArr3.push(item.time)
                    let value = Number(item.value[0] * ratio)
                    attr.value.push(value.toFixed(place).toString())
                    if(t.timeArr3.length >= 16){
                      t.timeArr3.splice(0,t.timeArr3.length - 15)
                    }
                    if(attr.value.length >= 16){
                      attr.value.splice(0,attr.value.length - 15)
                    }
                  }
                }
              }
            }
            if (t.type == 1) {
              t.setchart1(this.data.curveOneData[0])
            } else {
              t.setchart1(this.data.curveOneData[1])
            }
            t.$nextTick(()=>{
              t.$forceUpdate()
            })
            if (t.data.curveTwoData.dewId && topic.indexOf(t.data.curveTwoData.dewId) != -1) {
              let data = t.data.curveTwoData.dewDataset.properties
              let ratio = t.data.curveTwoData.dewDataset.ratio || 1
              let place = t.data.curveTwoData.dewDataset.place || 0
              if (data[0].property == item.propertyCode && item.value.length>0) {
                if (!data[0].value) {
                  data[0].value = []
                }
                let value = Number(item.value[0] * ratio)
                if(data[0].value.length == 15){
                  data[0].value.splice(0,1)
                  t.timeArr2.splice(0,1)
                }
                data[0].value.push(value.toFixed(place))
                t.timeArr2.push(item.time)
              }
            }
            if (t.data.curveTwoData.flowId && topic.indexOf(t.data.curveTwoData.flowId) != -1) {
              let data = t.data.curveTwoData.flowDataset.properties
              let ratio = t.data.curveTwoData.flowDataset.ratio || 1
              let place = t.data.curveTwoData.flowDataset.place || 0
              if (data[0].property == item.propertyCode && item.value.length>0) {
                if (!data[0].value) {
                  data[0].value = []
                }
                if(data[0].value.length == 15){
                  data[0].value.splice(0,1)
                  t.timeArr4.splice(0,1)
                }
                let value = Number(item.value[0] * ratio)
                data[0].value.push(value.toFixed(place))
                t.timeArr4.push(item.time)
              }
            }
            if (t.active == 1) {
              t.setchart2(t.data.curveTwoData.dewDataset)
            } else {
              t.setchart2(t.data.curveTwoData.flowDataset)
            }
          } else if (topic.indexOf('/property/push') != -1) {
            let valueList = this.valueList.filter(i => i.code == item.deviceCode)[0].list
            let obj = item.items
            for (let dev of this.data.deviceList) {
              if (dev.deviceCode == item.deviceCode) {
                if (item.offline == 1) {
                  dev.offline = true
                  this.$forceUpdate()
                }
              }
            }
            let arr = [];
            Object.keys(obj).forEach(function(key) { //将items转为键值对象
              let devObj = {};
              devObj.key = key;
              devObj.value = obj[key];
              arr.push(devObj);
            });
            for (let a of arr) {
              for (let b of valueList) { //比对标识符，修改value
                if (a.key == b.code) {
                  b.value = a.value
                }
              }
            }
            this.setState()
            if (this.$refs.dataView) {
              this.$refs.dataView.setData()
            }
            for (let obj of this.data.deviceList) {
              this.setOpen(obj)
            }
            this.$forceUpdate()
          } else if (topic.indexOf('/status/push') != -1) {
            // let dev = this.data.deviceList.filter(i=>i.deviceCode == item.deviceCode)[0]
            if(this.sendTime){
              this.sendTime= false
              this.getHold()
            }
            for (let dev of this.data.deviceList) {
              if (dev.deviceCode == item.deviceCode) {
                // 收到mqtt消息  设备在线
                // console.log(item)
                if (dev) {
                  // 1正常 2报警 3故障
                  let state = 0;
                  if (item.alarm.infor == 0 && item.alarm.warn == 0 && item.alarm.error == 0) {
                    state = 1
                  }
                  if (item.alarm.warn != 0) {
                    state = 2
                  }
                  if (item.alarm.error != 0) {
                    state = 3
                  }
                  dev.deviceState = state
                }
              }
            }
            this.$forceUpdate()
          }
        })
      },

      /*x轴只显示时间*/
      showsj(value) {
        var date = new Date(value);
        let y = date.getFullYear(),
          m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
          d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
          hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
          min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
          second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        //return y + '-' + m + '-' + d;
        return hours + ":" + min + ':' + second

      },

      /*Y-M-D H:M*/
      showrq(now) {
        if (now == "" || now == null || typeof now == 'string') {
          return
        }
        now = new Date(Number(now))
        let year = now.getFullYear(); //取得4位数的年份
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        let hour = now.getHours(); //返回日期中的小时数（0到23）
        let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
        let second = now.getSeconds(); //返回日期中的秒数（0到59）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if (hour < 10) {
          hour = "0" + hour
        }
        if (minute < 10) {
          minute = "0" + minute
        }

        return `${year+"-"+month+"-"+date} ${hour + ':' + minute}`;

      }
    },
    watch: {
      sendTime(){
        if(!this.sendTime){
          setTimeout(()=>{
            this.sendTime = true
          },4000)
        }
      },
      data(val, old) {
        // this.resetAttr

        // 获取设备的tsl
        this.infoDevice()
        // 获取加载速率
        this.infoRate()
        // 获取右侧设备数据
        this.infoData()
        this.infoEnergyData()
        this.infoStateData()
      },
      type() {
        // this.timeArr=[]
        if (!document.getElementById('chart1') == null) {
          this.$echarts.dispose(document.getElementById('chart1'))
        }
        if (this.type == 1 && this.data.curveOneData[0].id) {
          let data = this.data.curveOneData[0].dataset.properties
          for (let attr of data) {
            if (!attr.value) {
              attr.value = []
            }
          }
          this.setchart1(this.data.curveOneData[0])
        }
        if (this.type == 2 && this.data.curveOneData[1].id) {
          let data = this.data.curveOneData[1].dataset.properties
          for (let attr of data) {
            if (!attr.value) {
              attr.value = []
            }
          }
          this.get('/Dataset/getReport', {
            id: this.data.curveOneData[1].id,
            code: this.$store.state.companyCode
          }).then((res) => {
            if (res.success) {
              let data = this.data.curveOneData[0].dataset.properties
              let ratio = this.data.curveOneData[0].dataset.ratio || 1
              for (let attr of data) {
                let item = res.result.filter(i => i.propertyCode == attr.property)[0]
                if (item && item.data.length > 0) {
                  if (item.data[0].time&& attr.value.length==this.timeArr3.length&&item.data[0].time>this.timeArr3[this.timeArr3.length-1]) {
                    attr.value.push(item.data[0].value[0])
                    this.timeArr3.push(item.data[0].time)
                  }
                }
                this.setchart1(this.data.curveOneData[1])
              }
            }
          })
        }

      },
      active() {
        if (this.active == 1) {
          if (this.data.curveTwoData.dewId) {
            this.setchart2(this.data.curveTwoData.dewDataset)
          }
        } else {
          if (this.data.curveTwoData.flowId) {
            this.setchart2(this.data.curveTwoData.flowDataset)
          }
        }
      },
    },
    beforeRouteLeave(to, from, next) {
      from.meta.isBack = true;
      for (let url of this.subscribeArr) {
        this.mqttClient.unsubscribe(obj.url, () => {})
      }
      next();
    },
  }
</script>

<style scoped>
  .value-box {
    position: absolute;
    width: 100%;
    top: 132px;
    text-align: center;
  }

  .data-box-value {
    font-size: 25px;
    font-family: AgencyFB;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 28px;
  }

  .data-box-unit {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #627496;
  }

  .name-span {
    display: inline-block;
    width: 56px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: clip;
    white-space: nowrap;
    position: relative;
    top: 7px;
    margin-right: 12px;
  }

  .qiu {
    position: absolute;
    height: 93px;
    top: -5px;
    left: 84px;
    transform: rotate(-128deg);
    transition-duration: .2s;
    transform-origin: 50% 100%;
  }

  .neiqiu {
    width: 6px;
    height: 6px;
    background: #FFFFFF;
    border-radius: 50%;
    border: 2px solid;
    border-color: #00FFCC;
    border-radius: 50%;
  }

  .value-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #F82C31;
    line-height: 36px;
    margin-bottom: 5px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .pg {
    background-image: -webkit-linear-gradient(bottom, #FF6600, #fd8403, #FF9933);
  }

  .pd {
    background-image: -webkit-linear-gradient(bottom, #9ba49e, #9fa2a2, #afbdb8);
  }

  .zj {
    background-image: -webkit-linear-gradient(bottom, #41e273, #00fea8, #53e0b6);
  }

  .zhizheng {
    position: absolute;
    bottom: 95px;
    left: 85px;
    transform: rotate(-122.5deg);
    transition-duration: .2s;
    transform-origin: 4.5px 40px;
  }

  .sjx1 {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 40px solid;
    border-bottom-color: #ff8a01;
  }

  .sjx2 {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid;
    border-top-color: #ff8a01;
  }

  .yb-box {
    width: 177px;
    height: 200px;
    background: url(../../../assets/image/newmould/plate.png) no-repeat;
    /* background-size: 100% 100%; */
    /* background-position:center top; */
    margin: 0 auto;
  }

  .value {
    color: #fff;
    font-size: 16px;
    /* font-weight: bold; */
    font-family: AgencyFB;
    float: right;
  }

  .unit {
    color: #637498;
    font-size: 14px;
    font-weight: 400;
    margin-left: 6px;
  }

  #newModel {
    padding-top: 20px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 860px;
    text-align: left;
    background: -webkit-linear-gradient(#253853, #050613);
    /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#253853, #050613);
    /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#253853, #050613);
    /* Firefox 3.6 - 15 */
    background: linear-gradient(#253853, #050613);
    /* 标准的语法 */
  }

  .left-box {
    width: 53.4%;
    height: 93.4%;
    margin-left: 20px;
  }

  .device-list {
    width: 100%;
    height: 55.8%;
  }

  .list-title {
    color: #cbffff;
    font-weight: bold;
    font-size: 17px;
    padding: 20px 0 0 24px;
    box-sizing: border-box;
  }

  .state {
    text-align: right;
    padding: 12px 55px 0 0;
    background: url(../../../assets/image/newmould/titlebg.png) no-repeat;
    background-size: 480px 29px;
    background-position: 510px 9px;
  }

  .state-title {
    width: 510px;
    position: absolute;
    right: 7px;
    font-size: 15px;
    color: #ccfffc;
    text-align: center;
    top: 20px;
  }

  .state-title img {
    top: 9px;
    position: relative;
  }

  .state-lab {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-left: 38px;
    background: url(../../../assets/image/newmould/labbg.png) no-repeat;
    background-size: 18px 18px;
    background-position: 3px 3px;
  }

  .labbg1 {
    background: url(../../../assets/image/newmould/labbg1.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg2 {
    background: url(../../../assets/image/newmould/labbg2.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg3 {
    background: url(../../../assets/image/newmould/labbg3.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg4 {
    background: url(../../../assets/image/newmould/labbg4.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg5 {
    background: url(../../../assets/image/newmould/labbg5.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg6 {
    background: url(../../../assets/image/newmould/labbg6.png) no-repeat;
    background-size: 24px 24px;
  }

  .labbg7 {
    background: url(../../../assets/image/newmould/labbg7.png) no-repeat;
    background-size: 24px 24px;
  }

  .box-bg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .bg1 {
    background-image: url(../../../assets/image/newmould/bg1.png);
  }

  .bg2 {
    background-image: url(../../../assets/image/newmould/bg2.png);
  }

  .bg3 {
    background-image: url(../../../assets/image/newmould/bg3.png);
  }

  .bg4 {
    background-image: url(../../../assets/image/newmould/bg4.png);
  }

  .bg5 {
    background-image: url(../../../assets/image/newmould/bg5.png);
  }

  .bg6 {
    background-image: url(../../../assets/image/newmould/bg6.png);
  }

  .bg7 {
    background-image: url(../../../assets/image/newmould/bg7.png);
  }

  .divice-boxs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 38px;
    flex-wrap: wrap;
    height: 310px;
    overflow: auto;
  }

  .state-lamp {
    width: 20px;
    height: 25px;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(../../../assets/image/indexEditor/gray_error.png);
  }

  .device-box {
    width: 336px;
    height: 150px;
    padding: 20px 0 0 18px;
    box-sizing: border-box;
  }

  .device-box .f-l.p-r {
    width: 80px;
    text-align: center;
  }

  .border-bg {
    background: url(../../../assets/image/indexEditor/model7/border.png) no-repeat;
    background-position: 320px;
    background-size: 13px 68px;
  }

  .device-img {
    margin-top: 10px;
  }

  .attr-box {
    width: 190px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    margin-left: 18px;
  }

  .attr-box>p {
    font-size: 19px;
    margin-bottom: 4px;
  }

  .attr-box>div {
    font-weight: 500;
    font-size: 13px;
    line-height: 34px;
    color: #627495;
    width: 90%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .attr-box>div>span {
    font-weight: bold;
    color: #fff;
  }

  .category-box {
    height: 41.1%;
    margin-top: 22px;
  }

  .btns {
    height: 30px;
    width: 210px;
    border-radius: 5px;
    background-color: rgba(87, 96, 112, .5);
    margin: -10px auto 0;
  }

  .btns>span {
    display: inline-block;
    width: 48.9%;
    font-size: 13px;
    border-radius: 5px;
    line-height: 30px;
    text-align: center;
    color: #fff;
  }

  .btns>span.active {
    background-color: #576070;
  }

  .center-box {
    width: 27%;
    height: 93.4%;
    margin: 0 22px;
  }

  .category-box2 {
    height: 35%;
  }

  .data-boxs {
    width: 100%;
    height: 37.5%;
    margin-top: 24px;
  }
  #chart2,#chart1{
    height: 80%;
  }
  .data-box:first-child {
    margin-right: 20px;
  }

  .data-box {
    height: 100%;
    width: 48%;
  }

  .data-list {
    height: 90%;
    margin-top: 10px;
    padding: 0 0 0 12px;
    margin-right: 10px;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .data-list::-webkit-scrollbar,
  .list-data::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .data-list::-webkit-scrollbar-track,
  .list-data::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #2f3a4e;
    border-radius: 0;
  }

  /*滚动条的滑块按钮*/

  .data-list::-webkit-scrollbar-thumb,
  .list-data::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #DCDCDC;
  }

  /*滚动条的上下两端的按钮*/

  .data-list::-webkit-scrollbar-button,
  .list-data::-webkit-scrollbar-button {
    height: 0px;
    background-color: #2f3a4e;
  }

  .data-list p {
    color: #627598;
    font-size: 15px;
  }

  .warning-box {
    height: 21.2%;
    margin-top: 25px;
  }

  .waring-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .warning-lab {
    width: 138px;
    text-align: center;
    margin-top: -4px;
  }

  .warning-lab p {
    font-weight: bold;
    font-size: 24px;
    font-family: AgencyFB;
    color: #fff;
  }

  .warning-lab img {
    width: 52px;
    height: 61px;
  }

  .warning-lab div {
    font-size: 15px;
    color: #5f708f;
  }

  .right-box {
    width: 15.8%;
    height: 93.4%;
  }

  .now-data {
    height: 61%;
  }

  .star2 {
    display: inline-block;
    background-color: #647fa5;
    height: 6px;
    width: 6px;
    transform: rotate(45deg);
    margin-right: 4px;
    position: relative;
    top: -3px;
  }

  .list-data {
    padding: 0 30px;
    box-sizing: border-box;
    height: 90%;
    margin-right: 10px;
    overflow-x: auto;
  }

  .list-data p {
    font-size: 13px;
    line-height: 34px;
    color: #637498;
    padding-left: 1px;
  }

  .statistics {
    height: 35.6%;
    margin-top: 23px;
  }

  .statistics .list-data {
    height: 85%;
  }

  .state-lamp.lx {
    background-image: url(../../../assets/image/indexEditor/gray_error_system.png);
  }

  .state-lamp.gj {
    background-image: url(../../../assets/image/indexEditor/gray_error.png);
  }

  .state-lamp.gz {
    background-image: url(../../../assets/image/indexEditor/red_error.png);
  }

  .state-lamp.jg {
    background-image: url(../../../assets/image/indexEditor/yellow_error.png);
  }

  .state-lamp.zc {
    background-image: url(../../../assets/image/indexEditor/green_error.png);
  }

  .tuli {
    position: absolute;
    right: 35px;
    top: 10px;
    font-size: 12px;
    color: #C4E1FF;
  }

  .tuli span {
    border-top: 1px solid;
    display: inline-block;
    margin-right: 5px;
    width: 10px;
    position: relative;
    bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexEdit/mould/newMould.vue